const initialState = {
  viewer: {
    isAuthenticated: false,
    userName: '',
    errorCode: '',
  },
  statusText: '',
};

export default initialState;
